import { apiInstance } from './_base'

//
//

const BASE_URL = '/mini-app/meals'

//
//

/**
 *
 * @param {object} data
 * @param {string} data.date
 * @returns
 */

export const getMealsForDate = async (data) => {
  const res = await apiInstance.post(`${BASE_URL}/date`, {
    data,
  })

  return res
}

/**
 *
 * @param {object} data
 * @param {string} data.startDate
 * @param {string} data.endDate
 * @returns
 */

export const getMealsForPeriod = async (data) => {
  const res = await apiInstance.post(`${BASE_URL}/period`, {
    data,
  })

  return res
}

/**
 *
 * @param {number} logId
 * @returns
 */

export const getMeal = async (logId) => {
  const res = await apiInstance.get(`${BASE_URL}/${logId}`)

  return res
}

/**
 *
 * @param {number} logId
 * @param {*} data
 * @returns
 */

export const updateMeal = async (logId, data) => {
  const res = await apiInstance.put(`${BASE_URL}/${logId}`, {
    data,
  })

  return res
}

/**
 *
 * @param {number} logId
 * @returns
 */

export const deleteMeal = async (logId) => {
  const res = await apiInstance.delete(`${BASE_URL}/${logId}`)

  return res
}
